/**
 * Avatar for chat list: photo or initial. Optional click handler for profile.
 */

export interface ChatListItemAvatarProps {
  displayName: string;
  photoUrl?: string | null | undefined;
  onClick?: (() => void) | undefined;
}

export function ChatListItemAvatar({ displayName, photoUrl, onClick }: ChatListItemAvatarProps) {
  const content = photoUrl ? (
    <img src={photoUrl} alt={`${displayName}'s profile`} className="h-full w-full object-cover" />
  ) : (
    <div className="flex h-full w-full items-center justify-center bg-lavender-200">
      <span className="text-sm font-medium text-lavender-700">{displayName.charAt(0).toUpperCase()}</span>
    </div>
  );

  const className = "flex-shrink-0 h-12 w-12 overflow-hidden rounded-full bg-gray-300";

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={className}
        aria-label={`View ${displayName}'s profile`}
        data-testid="chat-list-item-avatar"
      >
        {content}
      </button>
    );
  }

  return (
    <div className={className} data-testid="chat-list-item-avatar">
      {content}
    </div>
  );
}
